import DocumentCard from "@bmi-digital/components/document-card";
import Grid from "@bmi-digital/components/grid";
import { CMSDocument } from "@bmi/elasticsearch-types";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import React from "react";
import BrandLogo from "../../../../components/BrandLogo";
import { useSiteContext } from "../../../../components/Site";

type Props = {
  documents: CMSDocument[];
};

const DocumentCardsResults = ({ documents }: Props) => {
  const { getMicroCopy } = useSiteContext();
  const getFileUrl = (url: string) => {
    if (url.includes("downloads.ctfassets.net")) {
      //Backward compatibility for Contentful documents
      return `https:${url}`;
    }

    if (url.startsWith("https")) {
      return url;
    }

    if (!process.env.GATSBY_PAYLOAD_ENDPOINT) {
      throw new Error(
        "GATSBY_PAYLOAD_ENDPOINT environment variable is not set."
      );
    }

    if (
      url.startsWith("/") ||
      process.env.GATSBY_PAYLOAD_ENDPOINT.endsWith("/")
    ) {
      return `${process.env.GATSBY_PAYLOAD_ENDPOINT}${url}`;
    }

    return `${process.env.GATSBY_PAYLOAD_ENDPOINT}/${url}`;
  };

  return (
    <Grid container spacing={3} data-testid="document-cards-results-grid">
      {documents.map((document, index) => {
        return (
          <Grid
            key={`${document.title}-${index}`}
            xs={12}
            sm={12}
            lg={6}
            xl={4}
          >
            <DocumentCard
              id={document.id}
              href={getFileUrl(document.asset.file.url)}
              noIndex={true}
              title={document.title}
              media={
                // @TODO use createImageProps after migrating all markets to Payload
                document.featuredMedia && {
                  src: document.featuredMedia.image.file.url,
                  alt: document.featuredMedia.altText
                }
              }
              brandLogo={
                document.BRAND ? (
                  <BrandLogo brandName={document.BRAND.name} />
                ) : undefined
              }
              gtm={{
                id: "cta-click1",
                label: getMicroCopy(microCopy.DOCUMENT_LIBRARY_CARD_DOWNLOAD),
                action: document.asset.file.url
              }}
              copyAccessibilityLabel={getMicroCopy(
                microCopy.DOCUMENT_LIBRARY_COPY_LINK_ACCESSIBILITY_LABEL
              )}
              copyLinkTooltip={getMicroCopy(
                microCopy.DOCUMENT_LIBRARY_COPY_LINK_TOOLTIP_TITLE
              )}
              linkCopiedTooltip={getMicroCopy(
                microCopy.DOCUMENT_LIBRARY_LINK_COPIED_TOOLTIP_TITLE
              )}
              downloadAccessibilityLabel={getMicroCopy(
                microCopy.DOCUMENT_LIBRARY_DOWNLOAD_ACCESSIBILITY_LABEL
              )}
              downloadTooltip={getMicroCopy(
                microCopy.DOCUMENT_LIBRARY_DOWNLOAD_TOOLTIP_TITLE
              )}
              clipboardErrorMessage={getMicroCopy(
                microCopy.COPY_LINK_ERROR_MESSAGE
              )}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default DocumentCardsResults;
